import { ErrorHandler, inject, Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { captureException } from "@sentry/angular";

interface SentryError {
	originalError: Error;
}

@Injectable()
export class CustomSentryErrorHandler implements ErrorHandler {
	private readonly zone = inject(NgZone);
	private readonly router = inject(Router);

	handleError(error: SentryError | unknown): void {
		console.error(error);
		const eventId = captureException((error as SentryError).originalError || error);

		this.zone.run(() => this.router.navigate(["/error"], { state: { eventId } }));
	}
}
